import * as core from '../../../../../../../core'

import { query } from './stakeholders-by-sentiment.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.by.sentiment',
    description: 'Chart view of stakeholders by sentiment',
    name: 'Stakeholders by Sentiment',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
